import React from 'react';
import { Widget } from '@typeform/embed-react';
import PropTypes from 'prop-types';

function HowDidYouHearAboutUsTypeForm({ onChangeStep, verificationsSteps }) {
    const handleSubmit = () => {
        onChangeStep(verificationsSteps[3]);
    };
    return (
        <>
            <Widget
                hideFooter
                hideHeaders
                onSubmit={handleSubmit}
                autoClose={100}
                id="OWarKXey"
                data-tf-widget="OWarKXey"
                data-tf-hide-headers
                data-tf-iframe-props="title=How did you hear about us"
                style={{ width: '100%', height: '100vh' }}
            />
            <script src="//embed.typeform.com/next/embed.js" />
        </>
    );
}

HowDidYouHearAboutUsTypeForm.propTypes = {
    onChangeStep: PropTypes.func.isRequired,
    verificationsSteps: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default HowDidYouHearAboutUsTypeForm;
